import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	constructor(public cookieService: CookieService) {
		super();
	}
	parse(): NgbDateStruct {
		return null;
	}

	format(date: NgbDateStruct): string {
		let stringDate = '';
		if (!date) {
			return stringDate;
		}
		const dateFormatted = new Date(date.year, date.month - 1, date.day);
		const languageCode = this.cookieService.get('BMLanguageCode');
		stringDate = new Intl.DateTimeFormat(languageCode).format(dateFormatted);
		return stringDate;
	}
}
